import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function BlogSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            Latest Kakobuy Spreadsheet Guides & Articles
          </h2>
          <p className="text-foreground-600 text-sm mt-3 max-w-xl">
            Expert guides to help you shop smarter, stay safe, and get the best deals from verified Yupoo sellers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 text-xs font-label font-semibold">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs text-primary-500 font-label">
                  Read Article
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}